module.exports = __webpack_public_path__ + "static/media/30.7e275a2d.jpg";